export default __webpack_public_path__ + "static/media/productHowItWorks1.4a86158b.svg";